module.exports = __webpack_public_path__ + "static/media/DSC_2897.4262e61c.jpg";